<desy-table-advanced classes="min-w-full">
  <desy-table-advanced-header>
    <desy-table-advanced-header-cell *ngFor="let item of itemsTableHeader">
      <desy-content>{{ item }}</desy-content>
    </desy-table-advanced-header-cell>
  </desy-table-advanced-header>
  <desy-table-advanced-row *ngFor="let item of itemsTableRows">
    <desy-table-advanced-row-cell>{{ item.name }}</desy-table-advanced-row-cell>
    <desy-table-advanced-row-cell>{{ item.post }}</desy-table-advanced-row-cell>
    <desy-table-advanced-row-cell>{{ item.selectedOrgCode }}</desy-table-advanced-row-cell>
    <desy-table-advanced-row-cell>{{ item.mail }}</desy-table-advanced-row-cell>
  </desy-table-advanced-row>
</desy-table-advanced>
